<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg" v-if="user">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      {{ header }}
    </div>

    <FormulateForm
      v-model="user_roles"
      :schema="schema"
      @submit="submitHandler"
    />
  </div>
</template>

<script>
import BaseCard from "../Accommodatie/BaseCard";
import { mapState } from "vuex";

const createSchema = roles => {
  let schema = [];
  for (let role of roles) {
    const checkbox = {
      type: "checkbox",
      name: role["id"],
      inputClass:
        "toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer",
      wrapperClass:
        "relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in",
      elementClass: ""
    };

    const row = {
      component: "div",
      class: "ml-4 my-2 grid grid-cols-2",
      id: Math.random().toString(),
      children: [
        {
          component: "div",
          children: role["role"]
        },
        checkbox
      ]
    };

    schema.push(row);
  }
  schema.push({
    name: "submit",
    type: "submit",
    "input-class": ["btn", "btn-blue"],
    label: "Opslaan"
  });
  return schema;
};

export default {
  name: "EditUserRolesCard",
  extends: BaseCard,
  data: function() {
    return {
      header: "Rollen",
      disabled: false,
      user_roles_to_submit: {}
    };
  },
  computed: {
    ...mapState({
      user(state) {
        const user_id = this.$route.params.id;
        return state.backend_data.users.find(u => u.id === user_id);
      }
    }),
    user_roles: {
      get: function() {
        return this.user.roles.reduce(
          (values, current_role) => ({
            ...values,
            [current_role["id"]]: true
          }),
          {}
        );
      },
      set: function(newValue) {
        this.user_roles_to_submit = newValue;
      }
    },
    schema: function() {
      return createSchema(this.$store.state.backend_data.roles);
    }
  },
  created: function() {
    this.$store.dispatch("ensureUsersAreLoaded");
    this.$store.dispatch("loadRoles");
  },
  methods: {
    submitHandler: async function() {
      const checked_role_ids = Object.entries(this.user_roles_to_submit)
        .filter(r => r[1] === true)
        .map(r => r[0]); //take the id
      this.$store.dispatch("updateUserRoles", {
        user_id: this.$route.params.id,
        role_ids: checked_role_ids
      });
    }
  }
};
</script>
